import { IBienLaiThuViewModel } from "../../../model/respone/bien-lai/IBienLaiThu";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IBienLaiViewChiTietBaseActionTypes<T> {
  request: IBienLaiPrintRequest;
  data: T;
}
export interface IBienLaiPrintRequest {
  id: number;
  mau_so: string;
  is_nop?: boolean;
}

export const eBienLaiViewChiTietActionsObj = {
  LOAD_START: {} as number,
  LOAD_SUCCESS: {} as IBienLaiThuViewModel,
  LOAD_ERRR: {} as IBienLaiViewChiTietBaseActionTypes<string>,

  PRINT_START: {} as IBienLaiPrintRequest,
  PRINT_SUCCESS: {} as IBienLaiViewChiTietBaseActionTypes<string>,
  PRINT_ERR: {} as IBienLaiViewChiTietBaseActionTypes<string>,
};
export const eBienLaiViewChiTietActionTypeIds = generateActionTypeIds(
  eBienLaiViewChiTietActionsObj,
  "BIEN_LAI_VIEW_CHI_TIET"
);
export type IBienLaiViewChiTietActionTypes = IGenericActionType<
  typeof eBienLaiViewChiTietActionsObj,
  "BIEN_LAI_VIEW_CHI_TIET"
>;
